module.exports = __webpack_public_path__ + "static/media/mainbg.698fd05c.jpg";